/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m24 12-3.5303-3.5303a.75.75 0 0 0-1.0607 1.0606l1.7197 1.7197H10.9393a.75.75 0 0 0 0 1.5h10.1894l-1.7197 1.7197a.75.75 0 0 0 1.0607 1.0606L24 12ZM3.75 2.25C2.5074 2.25 1.5 3.2574 1.5 4.5v15c0 1.2426 1.0074 2.25 2.25 2.25H16.5c1.2426 0 2.25-1.0074 2.25-2.25a.75.75 0 0 1 1.5 0c0 2.0711-1.6789 3.75-3.75 3.75H3.75C1.679 23.25 0 21.5711 0 19.5v-15C0 2.429 1.679.75 3.75.75H16.5c2.0711 0 3.75 1.679 3.75 3.75a.75.75 0 0 1-1.5 0c0-1.2426-1.0074-2.25-2.25-2.25H3.75Z"
    clipRule="evenodd"
  />,
  'Leave'
);
